import { render, staticRenderFns } from "./ProductsTypeCreate.vue?vue&type=template&id=5aed196f&scoped=true"
import script from "./ProductsTypeCreate.vue?vue&type=script&lang=js"
export * from "./ProductsTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed196f",
  null
  
)

export default component.exports